// Components==============
import Textarea from 'components/UI/Form/Textarea';
import { useRedux } from 'hooks/useRedux';
import React, { useContext, useState } from 'react';
import { ReflectionItemContext } from '../ReflectionItem';
import './ReflectionTextarea.module.scss';
// =========================

export default function ReflectionTextarea({
  item,
  value,
  setValue,
  handleSave,
}: {
  item: ReflectionNoteEntity;
  value?: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  handleSave?: () => void;
}) {
  const lang = useRedux(
    (state) => state.localize?.languages.find((l) => l.active)?.code
  ) as 'nl' | 'en' | undefined;

  const { activity } = useContext(ReflectionItemContext);
  const [isEditing, setIsEditing] = useState(false);

  function onSave() {
    if (handleSave) {
      setIsEditing(false);
      return handleSave();
    }
  }

  if (!lang) return <></>;

  if (setValue)
    return (
      <div styleName={`wrapper ${handleSave ? 'with-save' : ''}`}>
        <h3>{item.question[lang]}</h3>
        <span>{item.description[lang]}</span>
        <Textarea
          name=""
          placeholder={item.placeholder[lang]}
          ext_formValue={value}
          ext_onChange={(e) => {
            setIsEditing(true);
            setValue(e.target.value);
          }}
          handleSave={onSave}
          color={
            activity.process_type === 'App\\Phase' ? 'outline-grey' : 'grey'
          }
          isEditing={handleSave ? isEditing : undefined}
          setIsEditing={handleSave ? setIsEditing : undefined}
        />
      </div>
    );

  if (!item.answer) return <></>;

  return (
    <div styleName="wrapper">
      <strong>{item.question[lang]}</strong>
      <span>{item.description[lang]}</span>
      <p>{item.answer}</p>
    </div>
  );
}
